import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

/**
 * Pals primary palette — built around the brand color #1C5578, which
 * sits at the 600 step. Light shades (50–500) lean toward a clean
 * pale teal; dark shades (700–950) extend into deeper navy so PrimeNG
 * components have proper contrast in dark mode.
 */
export const PalsPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#eef5f9',
      100: '#d9e8f0',
      200: '#aacde0',
      300: '#7cb2cf',
      400: '#4090b6',
      500: '#2873a0',
      600: '#1c5578',
      700: '#174665',
      800: '#133a54',
      900: '#0f2e43',
      950: '#091e2c',
    },
  },
});
